export enum GroupTypeEnum {
  LIST = 'LIST',
  GROUP = 'GROUP',
}

export default GroupTypeEnum;
